import { Link, Navigate, useLocation } from "react-router-dom";
import { BrandExtraction } from "../components/brand/BrandExtraction";
import { useActiveBrand } from "../hooks/useActiveBrand";
import {
  buildAccountConnectionsPath,
  buildCorpusPath,
  LEGACY_BRAND_TAB_TO_ROUTE,
} from "../lib/brand-navigation";

// V2 bootstrap only: existing brands leave this route immediately for docs.
// Keep feature work in Workspace, Brand Docs, Tasks, Workflows, or utilities.
export function Brand() {
  const location = useLocation();
  const { activeBrand, isLoading } = useActiveBrand();

  if (isLoading) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-brand-600 border-t-transparent" />
      </div>
    );
  }

  if (activeBrand) {
    const tab = new URLSearchParams(location.search).get("tab") ?? "";
    const target =
      tab === "connections"
        ? buildAccountConnectionsPath(activeBrand.id)
        : tab === "corpus" || tab === "research"
          ? buildCorpusPath(activeBrand.id)
          : LEGACY_BRAND_TAB_TO_ROUTE[tab as keyof typeof LEGACY_BRAND_TAB_TO_ROUTE] ?? "";
    const to = target
      ? target.startsWith("/")
        ? target
        : `/brand/${activeBrand.id}/${target}`
      : `/brand/${activeBrand.id}/docs`;
    return <Navigate to={to} replace />;
  }

  return (
    <div className="mx-auto max-w-lg py-8">
      <div className="mb-4">
        <Link to="/home" className="text-sm text-slate-500 hover:text-slate-700">
          ← Back to workspace
        </Link>
      </div>
      <h2 className="mb-6 text-xl font-bold text-slate-900">Set up your brand</h2>
      <BrandExtraction />
    </div>
  );
}
